import { DataTable, FormDateRangePicker, FormSelect, Heading, Loader } from "@/components"
import useReportByOwner from "./useReportByOwner";
import { Info } from "lucide-react";
import { Button, Card, CardContent } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { DATE_RANGE, OWNER, PROPERTY } from "./consts";

const ReportByOwner = () => {
  const {breadcrumbData, title, form,
    ownerList, propertyOptions, isLoading,
    onRunReport, onClear, isDocLoading, columns,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    documentList, isRunBtnClicked,
    requiredFields} = useReportByOwner();
    const {errors} = form.formState;

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={title} breadcrumbData={breadcrumbData} />
      </div>

      <>
        <div className="rounded-md border-1 border-gray-300 bg-blue-100 p-3 text-[13px] flex flex-row gap-2 items-center">
          <Info className="stroke-primary" /> 
          <span>Please select one or more criteria to run the report.</span>
        </div>

        {isLoading ? <Loader /> : <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onRunReport)}>
            <Card className="my-6">
              <CardContent className="grid grid-cols-1 md:grid-cols-4 gap-[20px]">
                <FormSelect 
                  name={OWNER}
                  placeholder="Please Select"
                  label="Owner Name"
                  control={form.control}
                  options={ownerList?.map((data: any) => ({
                    label: `${data?.firstName} ${data?.lastName}`,
                    value: data?.occupancyId?.toString()
                  }))}
                  isRequired={requiredFields.includes(OWNER)}
                  error={errors[OWNER]?.message}
                />
                <FormSelect 
                  name={PROPERTY}
                  control={form.control}
                  label="Property Name"
                  placeholder="Please Select"
                  options={propertyOptions}
                  isRequired={requiredFields.includes(PROPERTY)}
                  error={errors[PROPERTY]?.message}
                />
                <FormDateRangePicker 
                  name={DATE_RANGE}
                  control={form.control}
                  label="Date Range"
                  placeholder="Please select"
                  isRequired={requiredFields.includes(DATE_RANGE)}
                  error={errors[DATE_RANGE]?.message}
                />
                <div className="flex flex-row items-center gap-2 justify-end">
                  <Button variant="outline" type="button" onClick={onClear}>Clear</Button>
                  <Button>Run Report</Button>
                </div>
              </CardContent>
            </Card>
          </form>
        </FormProvider>}

        {
          isRunBtnClicked ?
          isDocLoading ? <Loader /> :
            <DataTable
              columns={columns}
              data={documentList?.data || []}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              pageSize={pageSize}
              totalPages={Math.ceil(documentList?.total / pageSize)}
              totalRecords={documentList?.total}
              serverSidePagination={true}
              sorting={sorting}
              onSortingChange={setSorting}
            /> : <></>
        }
      </>
    </div>
  )
}

export default ReportByOwner;